import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import '../styles/fencing.css';
import CTASection from '../components/CTASection';

const Fence = () => {
  return (
    <div className="fence-page">
      <Navbar />
      {/* Hero Section */}
       <section className="fence-hero">
        <div>
              <img src="/images/fence/fenceHeroImage.png" alt="All Seasons Fence" className="hero-image" loading="eager" decoding="async" />
            </div>
        <div className="fence-hero-overlay">
          <div className="fence-hero-content">
            <h1 className="fence-hero-title">Expert Fencing Solutions for The Valley Properties</h1>
            <p className="fence-hero-subtitle">
              From working ranches to luxury estates – Function and Form perfectly balanced
            </p>
             <div className="hero-buttons">
                        <a
                      className="btn-cta"
                      href="mailto:info@allseasons.info"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Request A Consultation</a>
                        <Link to="/gallery/landscape" className="btn-primary">Gallery</Link>
                      </div>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Complete Fencing Services</h2>
          <p className="intro-text text-center" style={{ maxWidth: '900px', margin: '0 auto 3rem auto' }}>
            All Seasons Landscaping brings decades of experience to every fencing project. Whether you need to contain livestock,
            protect gardens from wildlife, enhance security, or simply define your property boundaries with style, we deliver
            solutions that stand the test of time. Our team understands that three key factors guide every fence decision:
            Function, Form, and Budget – and we excel at balancing all three.
          </p>
          <div className="value-props-grid">
            <div className="value-prop-card">
              <div className="value-number">01</div>
              <h3>Custom Design</h3>
              <p className="value-description">
                Tailored solutions for your specific needs and property
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">02</div>
              <h3>Professional Installation</h3>
              <p className="value-description">
                Expert crews with specialized equipment
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">03</div>
              <h3>Repair & Maintenance</h3>
              <p className="value-description">
                Keep your investment looking and working great
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">04</div>
              <h3>Code Compliance</h3>
              <p className="value-description">
                Meeting all Idaho and local regulations
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ranch & Farm Fencing Section */}
      {/* <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Ranch & Farm Fencing</h2>
          <p className="section-intro">Professional livestock management and agricultural fencing solutions</p>
        </div>
      </section>

      <ContentSplitSections sections={ranchFarmFencing} /> */}

      {/* Residential & Decorative Section */}
      {/* <section className="section bg-soft-stone">
        <div className="section-inner">
          <h2 className="section-title text-center">Residential & Decorative Fencing</h2>
          <p className="section-intro">Enhance your property's beauty, privacy, and value</p>
        </div>
      </section>

      <ContentSplitSections sections={residentialDecorativeFencing} /> */}

      {/* Specialty Applications */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Specialty Fencing Applications</h2>
          <p className="section-intro">Unique solutions for Sun Valley's diverse fencing needs</p>
          
          <div className="specialty-grid">
            <div className="specialty-card fence-specialty-card">
              <h3>Snow Fencing</h3>
              <p className="application-type">Drift Control</p>
              <p>Strategic placement to manage snow accumulation and protect driveways, buildings, and sensitive areas.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Pool & Safety Fencing</h3>
              <p className="application-type">Code Compliant</p>
              <p>Meeting all safety requirements while maintaining your property's aesthetic appeal.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Construction Fencing</h3>
              <p className="application-type">Temporary Solutions</p>
              <p>Secure job sites and protect the public during your construction or renovation projects.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Pet Containment</h3>
              <p className="application-type">Custom Design</p>
              <p>Keep your furry friends safe with attractive fencing that complements your landscape.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Garden Protection</h3>
              <p className="application-type">Wildlife Resistant</p>
              <p>Protect vegetables, flowers, and ornamentals from deer, rabbits, and other garden visitors.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Sound Barriers</h3>
              <p className="application-type">Privacy Plus</p>
              <p>Reduce noise from roads or neighbors while creating private outdoor spaces.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
     <CTASection 
  title="Ready to Define Your Boundaries?"
  subtitle="From initial consultation through final installation, we make fencing simple. Let's discuss your project and find the perfect solution for your property."
  galleryLink="/Gallery/fencing"
  showEmergency={false}
/>
    </div>
  );
};

export default Fence;